import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, isRef as _isRef } from "vue"

const _hoisted_1 = ["inert"]
const _hoisted_2 = ["inert"]
const _hoisted_3 = ["disabled"]
const _hoisted_4 = { class: "camera-file-workspace" }
const _hoisted_5 = { class: "camera-file-toolbar" }
const _hoisted_6 = {
  class: "save-status",
  role: "status"
}
const _hoisted_7 = {
  key: 0,
  class: "duration-field"
}
const _hoisted_8 = ["value"]
const _hoisted_9 = {
  key: 0,
  class: "file-error",
  role: "alert"
}
const _hoisted_10 = {
  key: 1,
  class: "camera-file-scroll"
}
const _hoisted_11 = { class: "camera-file-card" }
const _hoisted_12 = {
  key: 2,
  class: "studio-empty"
}
const _hoisted_13 = {
  key: 0,
  class: "file-error",
  role: "alert"
}

import SectionLayout from "@/components/Layout/SectionLayout.vue";
import { downloadTextFile } from "@/utils/download";
import { toast } from "vue-sonner";
import { ref } from "vue";
import StudioHistoryToolbar from "../StudioHistoryToolbar.vue";
import { useStudioDocumentHistory } from "../useStudioHistory";
import StudioFileList from "../StudioFileList.vue";
import StudioSidebarContent from "../StudioSidebarContent.vue";
import StudioCreateDialog from "../StudioCreateDialog.vue";
import CameraClipEditor from "../DialogueEditor/components/clip-editors/CameraClipEditor.vue";
import { exportQxqyCameraClip } from "../DialogueEditor/utils/qxqyPerformanceExporter";
import { useWorkspaceStructIds } from "../useWorkspaceStructIds";
import { useCameraFiles } from "./useCameraFiles";
import type { StudioEditorKind } from "../studioSidebar";


export default /*@__PURE__*/_defineComponent({
  __name: 'CameraEditor',
  props: {
    editorKind: { default: "Camera" }
  },
  setup(__props: any, { expose: __expose }) {



const { project, files, selectedFile, creating, newName, busy, status, error,
  refreshFiles, selectFile, createFile, deleteFile, prepareToLeave, flush } = useCameraFiles();
const workspaceIds = useWorkspaceStructIds();
const historyElement = ref<HTMLElement>();
const history = useStudioDocumentHistory({
  project, element: historyElement, blocked: () => busy.value, label: "修改镜头",
  onError: reason => toast.error(reason instanceof Error ? reason.message : "镜头恢复失败"),
});
__expose({ prepareToLeave });
function updateDuration(event: Event) {
  if (!project.value) return;
  const input = event.target as HTMLInputElement;
  if (Number.isFinite(input.valueAsNumber) && input.valueAsNumber >= 0.1) project.value.clip.duration = input.valueAsNumber;
  input.value = String(project.value.clip.duration);
}
function exportCamera() {
  if (busy.value || !project.value) return;
  try {
    const result = exportQxqyCameraClip(project.value.clip, workspaceIds.camera());
    downloadTextFile(result.json, `${selectedFile.value.replace(/\.json$/i, "")}-镜头.json`, "application/json");
  } catch (reason) { toast.error(reason instanceof Error ? reason.message : String(reason)); }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    ref_key: "historyElement",
    ref: historyElement,
    class: "camera-file-editor",
    inert: _unref(busy)
  }, [
    _createVNode(StudioSidebarContent, null, {
      default: _withCtx(() => [
        _createElementVNode("div", {
          class: "camera-file-sidebar",
          inert: _unref(busy)
        }, [
          _cache[6] || (_cache[6] = _createElementVNode("div", { class: "studio-sidebar-heading" }, [
            _createElementVNode("strong", null, "镜头文件")
          ], -1)),
          _createVNode(StudioFileList, {
            disabled: _unref(busy),
            values: _unref(files),
            "selected-value": _unref(selectedFile),
            onSelect: _unref(selectFile),
            onAdd: _cache[0] || (_cache[0] = ($event: any) => (creating.value = true)),
            onDelete: _unref(deleteFile)
          }, null, 8, ["disabled", "values", "selected-value", "onSelect", "onDelete"]),
          _createElementVNode("button", {
            type: "button",
            class: "refresh-files",
            disabled: _unref(busy),
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_unref(refreshFiles) && _unref(refreshFiles)(...args)))
          }, "刷新列表", 8, _hoisted_3)
        ], 8, _hoisted_2)
      ]),
      _: 1
    }),
    _createVNode(SectionLayout, {
      title: _unref(selectedFile) || '镜头编辑',
      class: "camera-file-section"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("header", _hoisted_5, [
            _createElementVNode("span", _hoisted_6, _toDisplayString(_unref(status)), 1),
            _createVNode(StudioHistoryToolbar, {
              history: _unref(history),
              disabled: _unref(busy)
            }, null, 8, ["history", "disabled"]),
            (_unref(project))
              ? (_openBlock(), _createElementBlock("label", _hoisted_7, [
                  _cache[7] || (_cache[7] = _createTextVNode("时长（秒）", -1)),
                  _createElementVNode("input", {
                    type: "number",
                    min: "0.1",
                    step: "0.1",
                    "aria-label": "镜头时长（秒）",
                    value: _unref(project).clip.duration,
                    onChange: updateDuration
                  }, null, 40, _hoisted_8)
                ]))
              : _createCommentVNode("", true),
            (_unref(project))
              ? (_openBlock(), _createElementBlock("button", {
                  key: 1,
                  type: "button",
                  class: "primary",
                  onClick: exportCamera
                }, "导出千星镜头"))
              : _createCommentVNode("", true)
          ]),
          (_unref(error) && !_unref(creating))
            ? (_openBlock(), _createElementBlock("p", _hoisted_9, [
                _createTextVNode(_toDisplayString(_unref(error)) + " ", 1),
                (_unref(status) === '保存失败')
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 0,
                      type: "button",
                      onClick: _cache[2] || (_cache[2] = ($event: any) => (_unref(flush)().catch(() => undefined)))
                    }, "重试保存"))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true),
          (_unref(project))
            ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                _createElementVNode("div", _hoisted_11, [
                  (_openBlock(), _createBlock(CameraClipEditor, {
                    key: _unref(selectedFile),
                    clip: _unref(project).clip
                  }, null, 8, ["clip"]))
                ])
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_12, [
                _cache[8] || (_cache[8] = _createElementVNode("h2", null, "编辑一份镜头", -1)),
                _cache[9] || (_cache[9] = _createElementVNode("p", null, "从左侧选择文件，或新建一个镜头。", -1)),
                _createElementVNode("button", {
                  type: "button",
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (creating.value = true))
                }, "＋ 新建镜头文件")
              ]))
        ])
      ]),
      _: 1
    }, 8, ["title"]),
    (_unref(creating))
      ? (_openBlock(), _createBlock(StudioCreateDialog, {
          key: 0,
          modelValue: _unref(newName),
          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_isRef(newName) ? (newName).value = $event : null)),
          title: "新建镜头文件",
          label: "镜头文件名",
          placeholder: "输入镜头文件名",
          "submit-label": "创建并打开",
          busy: _unref(busy),
          onSubmit: _unref(createFile),
          onClose: _cache[5] || (_cache[5] = ($event: any) => (creating.value = false))
        }, {
          default: _withCtx(() => [
            (_unref(error))
              ? (_openBlock(), _createElementBlock("p", _hoisted_13, _toDisplayString(_unref(error)), 1))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["modelValue", "busy", "onSubmit"]))
      : _createCommentVNode("", true)
  ], 8, _hoisted_1))
}
}

})